/* global axios */
import ApiClient from './ApiClient';
import store from '../store';

const getInstallationData = () => {
  return {
    installation_identifier:
      window.installationConfig?.installationIdentifier ||
      store.state.globalConfig.installationIdentifier,
    installation_version:
      window.installationConfig?.version || store.state.globalConfig.version,
    installation_host: window.location.hostname,
    installation_env: process.env.NODE_ENV,
    edition:
      window.installationConfig?.edition || store.state.globalConfig.edition,
    account_id: store.state.auth.currentUser?.account_id,
    user_id: store.state.auth.currentUser?.id,
    user_role: store.state.auth.currentUser?.role,
  };
};

const sendTelemetry = async (eventName, eventData = {}) => {
  // COMENTADO: Removido telemetria para StackLab para evitar conexões externas
  // try {
  //   const baseUrl = 'https://api.os.stacklab.digital/api';
  //   const eventsUrl = `${baseUrl}/events`;
  //   const installationData = getInstallationData();

  //   const info = {
  //     event_name: `funnel_${eventName}`,
  //     event_data: {
  //       ...eventData,
  //       ...installationData,
  //       component: 'FunnelAPI',
  //       timestamp: new Date().toISOString(),
  //     },
  //   };

  //   await fetch(eventsUrl, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //     },
  //     body: JSON.stringify(info),
  //   });
  // } catch (error) {
  //   // Silently fail to not disrupt user experience
  //   console.error('Telemetry error:', error);
  // }

  // ✅ TELEMETRIA DESABILITADA: Funcionalidade mantida sem envio de dados
  console.log(`Telemetry disabled: funnel_${eventName}`, eventData);
};

class FunnelAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  async create(data) {
    return axios.post(this.url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async reorderStages(id, stages) {
    return axios.patch(
      `${this.url}/${id}/reorder`,
      { stages },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }
}

export default new FunnelAPI();
